<template>
	<div class="opts_wrap" v-loading="loading">
		<p style="margin-bottom: 10px;">快递网点信息：</p>
		<div class="opts_line">
			<p class="txt">物流公司：</p>
			<div class="con">
				<el-select class="w100" v-model="form.company_id" placeholder="请选择" clearable @change="selectCompany">
					<el-option v-for="item in companies" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</div>
		</div>
		<div class="opts_line">
			<p class="txt">打印模板：</p>
			<div class="con">
				<el-select class="w100" v-model="form.template_size" placeholder="请选择" clearable @change="selectTemplate">
					<el-option v-for="item in templateSize" :key="item.value" :label="item.name" :value="item.value">
					</el-option>
				</el-select>
			</div>
		</div>
		<div class="opts_line">
			<div class="con">
				<el-input v-model="form.remark_name" clearable>
					<p slot="prefix" class="label_title">备注名：</p>
				</el-input>
			</div>
		</div>
		<div class="opts_line" v-if="CustomerName">
			<div class="con">
				<el-input v-model="form.customer_name" clearable>
					<p slot="prefix" class="label_title">账号：</p>
				</el-input>
			</div>
		</div>
		<div class="opts_line" v-if="MonthCode">
			<div class="con">
				<el-input v-model="form.month_code" clearable>
					<p slot="prefix" class="label_title">月结号：</p>
				</el-input>
			</div>
		</div>
		<div class="opts_line" v-if="CustomerPwd">
			<div class="con">
				<el-input v-model="form.customer_pwd" clearable>
					<p slot="prefix" class="label_title">密码：</p>
				</el-input>
			</div>
		</div>
		<div class="opts_line" v-if="SendSite">
			<div class="con">
				<el-input v-model="form.send_site" clearable>
					<p slot="prefix" class="label_title">归属网点：</p>
				</el-input>
			</div>
		</div>
		<!-- address -->
		<p style="margin-bottom: 10px;">发货地址信息：</p>
		<div class="opts_line">
			<div class="con">
				<el-input v-model="form.name" clearable>
					<p slot="prefix" class="label_title">姓名：</p>
				</el-input>
			</div>
		</div>
		<div class="opts_line">
			<div class="con">
				<el-input v-model="form.mobile" clearable>
					<p slot="prefix" class="label_title">手机号：</p>
				</el-input>
			</div>
		</div>
		<div class="opts_line">
			<div class="con">
				<div class="lb">省市区：</div>
				<el-cascader
					:placeholder="deliverAddressName"
				  v-model="deliverRegionId"
					:props="regionProps"
				  @change="deliverRegionChange">
					</el-cascader>
			</div>
		</div>
		<div class="opts_line">
			<div class="con">
				<el-input v-model="form.address" clearable>
					<p slot="prefix" class="label_title">详细地址：</p>
				</el-input>
			</div>
		</div>
		<div class="opts_line">
			<div class="con">
				<el-input v-model="form.post_code" clearable>
					<p slot="prefix" class="label_title">邮编：</p>
				</el-input>
			</div>
		</div>
		<div class="btn_wrap">
			<p class="btn" @click="saveBtn()">提交</p>
			<p class="btn" @click="cancel()">取消</p>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import {supplierRegionList} from "../../api/main/ucenter.js";
import { mapActions,mapState,mapMutations } from "vuex";
export default {
	name: "bindLogistics",
	props: {
		isLoading: {
			type: Boolean,
			default: false
		},
		show: {
			type: Boolean,
			default: false
		},
		
	},
	data() {
		return {
			CustomerName:false,
			CustomerPwd:false,
			MonthCode:false,
			SendSite:false,
			address:'',
			kdn_lcb_field:[],
			form:{
				company_id:'',
				remark_name:'',
				customer_name:'',
				customer_pwd:'',
				month_code:'',
				send_site:'',
				name:'',
				mobile:'',
				address:'',
				post_code:'',
				region_id:'',
				template_size:'',
				page_width:'',
				page_height:''
			},
			deliverRegionId:[],
			deliverAddressName: '',
			companies:[],
			templateSizeList:[],
			templateSize:[],
			regionProps:{
				value:'id',
				label:'name',
				lazy: true,
				lazyLoad (node, resolve) {
										var cate = node?node:{value:0,level:1};
										var level = 3//显示省市区街道层级
										var param = {pid:cate.value,level:level}
											supplierRegionList(param).then(res => {
											if(res.code == 200){
												let list = res.data
												// console.log('leaf_list:',list)
												const nodes = Array.from(list)
													.map(item => ({
														id: item.id,
														name: item.name,
														level: item.level,
														leaf: (item.children_count>0&&level>item.level)?0:1,//0为有下级 1为没有
													}));
												// console.log(nodes)
												resolve(nodes);
											}	
										})
									}
			},
			loading: false
		};
	},
	
	created(){
	},
	mounted() {
		
		this.init()
	},
	
	computed:{
		...mapState({
			
		}),
	},
	watch:{
		show(val) {
			if(val){
				this.CustomerName = false
				this.CustomerPwd = false
				this.MonthCode = false
				this.SendSite = false
				this.deliverRegionId = []
				this.form = {
					company_id:'',
					remark_name:'',
					customer_name:'',
					customer_pwd:'',
					month_code:'',
					send_site:'',
					name:'',
					mobile:'',
					province_name:'',
					city_name:'',
					exp_area_name:'',
					address:'',
					post_code:'',
					region_id:'',
					template_size:'',
					page_width:'',
					page_height:''
				}
				this.init()
			}
		}
	},
	
	methods: {
		...mapActions({
			getUnboundLogisticsCompany:"ucenter/getUnboundLogisticsCompany",
			opSubBindLogisticsCompany:"ucenter/opSubBindLogisticsCompany",
		}),
		init(){
			this.loading = true
			this.getUnboundLogisticsCompany({data:{},success:(res)=>{
				console.log(res)
				if(res.code===200){
					this.companies = res.data.logistics_company
					this.templateSizeList = res.data.template_size_list
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
				this.loading = false
			}})
		},
		selectCompany(id){
			if(!id){
				this.CustomerName = false
				this.CustomerPwd = false
				this.MonthCode = false
				this.SendSite = false
				this.form.template_size = ''
				this.templateSize = []
				return
			}
			let companies = this.companies
			let company = companies.find(val => val.id == id)
			let field_arr = company.kdn_lcb_field_arr
			this.CustomerName = field_arr.includes('CustomerName')
			this.CustomerPwd = field_arr.includes('CustomerPwd')
			this.MonthCode = field_arr.includes('MonthCode')
			this.SendSite = field_arr.includes('SendSite')
			this.form.template_size = '0'
			this.templateSize = this.templateSizeList[company.kdn_company_code]
		},
		selectTemplate(value){
			// console.log(value)
			let template = this.templateSize.find(val => val.value == value)
			this.form.page_width = template.width
			this.form.page_height = template.height
		},
		deliverRegionChange(value) {
			this.form.region_id = value
		},
		cancel(){
			this.$emit('close', {})
		},
		saveBtn(){
			let that = this
			let param = {}
			param = Object.assign(this.form,param)
			console.log(param)
			if(!param.company_id){
				that.$message({
					type: 'warning',
					message: '请选择快递公司'
				})
				return
			}
			if(param.template_size==''){
				that.$message({
					type: 'warning',
					message: '请选择打印模板'
				})
				return
			}
			if(!param.customer_name && this.CustomerName){
				that.$message({
					type: 'warning',
					message: '请输入账号'
				})
				return
			}
			if(!param.customer_pwd && this.CustomerPwd){
				that.$message({
					type: 'warning',
					message: '请输入密码'
				})
				return
			}
			if(!param.month_code && this.MonthCode){
				that.$message({
					type: 'warning',
					message: '请输入月结编号'
				})
				return
			}
			if(!param.send_site && this.SendSite){
				that.$message({
					type: 'warning',
					message: '请输入归属网点'
				})
				return
			}
			that.opSubBindLogisticsCompany({data:param,success:(res)=>{
				if(res.code == 200){
					that.$message({
						type: 'success',
						message: res.msg
					})
					this.$emit('success')
					this.$emit('close')
				}else{
					that.$message({
						type: 'error',
						message: res.msg
					})
				}
			}})
		}
	},

}
</script>

<style scoped>
	.opts_wrap{padding-top: 14px;}
	.opts_wrap .label_title{color: #C0C4CC !important;}
	.opts_wrap .opts_line{display: flex;align-items: center;position: relative;margin-bottom: 20px;}
	.opts_line .txt{width: 80px;text-align: left;font-size: 14px;position: absolute;left: 14px;z-index: 1;color: #C0C4CC !important;}
	.opts_line .con{flex: 1;width: 0;margin-left: 0px;display: flex;align-items: center;position: relative;}
	.opts_line .con .lb{position: absolute;left: 13px;font-size: 14px;color: #C0C4CC;z-index: 1;}
	.opts_line .con .t{font-size: 14px;}
	.opts_wrap .btn_wrap{margin: 40px auto 0 auto;display: flex;align-items: center;justify-content: center;}
	.opts_wrap .btn_wrap .btn{width: 80px;height: 34px;border-radius: 4px;display: flex;justify-content: center;align-items: center;cursor: pointer;box-sizing: border-box;font-size: 14px;}
	.opts_wrap .btn_wrap .btn:nth-child(1){background: var(--red);color: #fff;margin-right: 14px;}
	.opts_wrap .btn_wrap .btn:nth-child(2){background: #fff;color: #333;border: 1px solid #ddd;margin-right: 14px;}
	.ml8{margin-left: 8px;}
	.opts_wrap .btn_wrap .btn:nth-child(3){background: #fff;color: #333;border: 1px solid #ddd;}
	.w80{width: 80px;}
	.w100{width: 100%;}
	.s_line{padding:0 12px;height: 34px;line-height: 34px;border:1px solid #DCDFE6;border-radius:4px;width: 100%;}
	.s_line .label{color:#C0C4CC;font-size:14px;width: 68px;display:inline-block;}
	.s_line .info{display:inline-block;}
	/deep/.el-input__icon{line-height: 34px !important;}
	/deep/.el-input__prefix{height:34px !important;line-height:34px !important;margin-left:9px;}
	/deep/.el-select .el-input__inner{padding-left:80px;height:34px;line-height:34px;}
	/deep/.el-input--prefix .el-input__inner, .el-cascader .el-input .el-input__inner{padding-left:80px;height: 34px !important;}
</style>
<style>
	/*red border color*/
	.el-button.is-plain:focus, .el-button.is-plain:hover ,.el-checkbox__inner:hover ,.el-checkbox__input.is-focus .el-checkbox__inner,.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus, .el-input .el-input__inner:focus,.el-input .el-input__inner:focus, .el-input.is-focus .el-input__inner{border-color: var(--red) !important;}
</style>
